/* =========================================================================
   METROPUNK — theme JS
   Vanilla only. No jQuery, no framework, no build step.

   Everything here is progressive enhancement: the site is fully shoppable
   with JS disabled (forms POST, links navigate, content is visible).
   ========================================================================= */
(function () {
  'use strict';

  var MP = window.MP || {};
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents) {
    var fmt = MP.money_format || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    // Shopify money formats we care about: amount, amount_no_decimals,
    // amount_with_comma_separator. Anything else falls back to plain.
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, token) {
      if (token === 'amount_no_decimals') return Math.round(cents / 100).toString();
      if (token === 'amount_with_comma_separator') return amount.replace('.', ',');
      return amount;
    });
  }

  /* --- focus trap ------------------------------------------------------- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';

  function trap(panel) {
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var items = $$(FOCUSABLE, panel).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    var closer = null;
    function close() { if (closer) closer(); }
    document.addEventListener('keydown', onKey);
    return {
      onClose: function (fn) { closer = fn; },
      release: function () { document.removeEventListener('keydown', onKey); }
    };
  }

  /* --- generic panel (mobile nav, cart drawer, search) ------------------ */
  function Panel(el, opts) {
    opts = opts || {};
    var overlay = $('[data-overlay]');
    var lastFocus = null;
    var release = null;

    function open() {
      lastFocus = document.activeElement;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      el.removeAttribute('hidden');
      if (overlay && opts.overlay !== false) {
        overlay.removeAttribute('hidden');
        // next frame so the transition actually runs
        requestAnimationFrame(function () { overlay.classList.add('is-open'); });
      }
      document.body.style.overflow = 'hidden';
      var t = trap(el);
      t.onClose(close);
      release = t.release;
      var target = $(opts.focus || FOCUSABLE, el);
      if (target) target.focus();
      $$('[aria-controls="' + el.id + '"]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
      if (opts.onOpen) opts.onOpen();
    }

    function close() {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      if (overlay) {
        overlay.classList.remove('is-open');
        setTimeout(function () {
          if (!$('.is-open[data-cart-drawer],.is-open[data-mnav],.is-open[data-psearch]')) {
            overlay.setAttribute('hidden', '');
          }
        }, 320);
      }
      document.body.style.overflow = '';
      if (release) { release(); release = null; }
      $$('[aria-controls="' + el.id + '"]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      if (opts.hideOnClose) setTimeout(function () { el.setAttribute('hidden', ''); }, 320);
      if (lastFocus) lastFocus.focus();
    }

    if (overlay) overlay.addEventListener('click', close);
    return { open: open, close: close, el: el };
  }

  /* --- mobile nav ------------------------------------------------------- */
  function initNav() {
    var el = $('[data-mnav]');
    if (!el) return;
    var panel = Panel(el);
    $$('[data-mnav-open]').forEach(function (b) {
      b.addEventListener('click', panel.open);
    });
    $$('[data-mnav-close]').forEach(function (b) {
      b.addEventListener('click', panel.close);
    });
  }

  /* --- cart ------------------------------------------------------------- */
  var cartPanel = null;

  function initCart() {
    var el = $('[data-cart-drawer]');
    if (!el) return;
    cartPanel = Panel(el);

    $$('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); cartPanel.open(); });
    });
    $$('[data-cart-close]').forEach(function (b) {
      b.addEventListener('click', cartPanel.close);
    });

    // Quantity steppers + removal, delegated so re-rendered markup keeps working
    el.addEventListener('click', function (e) {
      var line = e.target.closest('[data-line]');
      if (!line) return;
      var input = $('[data-qty-input]', line);
      if (!input) return;
      var q = parseInt(input.value, 10) || 0;
      if (e.target.closest('[data-qty-up]')) changeLine(line.dataset.line, q + 1);
      if (e.target.closest('[data-qty-down]')) changeLine(line.dataset.line, Math.max(0, q - 1));
    });

    el.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (!input) return;
      var line = input.closest('[data-line]');
      changeLine(line.dataset.line, Math.max(0, parseInt(input.value, 10) || 0));
    });
  }

  function changeLine(line, quantity) {
    var drawer = $('[data-cart-drawer]');
    if (drawer) drawer.setAttribute('aria-busy', 'true');
    fetch(MP.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () { window.location.href = MP.routes.cart; })
      .finally(function () { if (drawer) drawer.removeAttribute('aria-busy'); });
  }

  function addToCart(id, qty, btn) {
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.dataset.label = btn.textContent; }
    return fetch(MP.routes.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch(MP.routes.cart + '.js').then(function (c) { return c.json(); });
      })
      .then(function (cart) {
        renderCart(cart);
        if (cartPanel) cartPanel.open();
      })
      .catch(function () {
        if (btn) {
          btn.textContent = MP.strings.add_error || 'Try again';
          setTimeout(function () { btn.textContent = btn.dataset.label; }, 2200);
        }
      })
      .finally(function () { if (btn) btn.removeAttribute('aria-disabled'); });
  }

  function renderCart(cart) {
    if (!cart) return;

    $$('[data-cart-count]').forEach(function (n) {
      n.textContent = cart.item_count;
      if (cart.item_count > 0) n.removeAttribute('hidden'); else n.setAttribute('hidden', '');
    });
    var countText = $('[data-cart-count-text]');
    if (countText) countText.textContent = '(' + cart.item_count + ')';

    var body = $('[data-cart-body]');
    var foot = $('[data-cart-foot]');
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML =
        '<div class="center" style="padding-block:var(--sp-7)">' +
        '<p class="f-pix" style="color:var(--muted)">Nothing in here yet.</p>' +
        '<hr class="chain" aria-hidden="true">' +
        '<a class="btn btn--neon btn--sm" href="' + MP.routes.cart + '"><span>Keep looking</span></a></div>';
      if (foot) foot.setAttribute('hidden', '');
      return;
    }
    if (foot) foot.removeAttribute('hidden');

    body.innerHTML = cart.items.map(function (item, i) {
      var img = item.image
        ? '<img class="citem__img" src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') +
          '" width="160" height="200" loading="lazy" alt="">'
        : '';
      var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1)
        ? '<div class="citem__v">' + esc(item.variant_title) + '</div>' : '';
      return (
        '<div class="citem" data-line="' + (i + 1) + '">' +
          '<a href="' + item.url + '">' + img + '</a>' +
          '<div>' +
            '<a class="citem__n" href="' + item.url + '">' + esc(item.product_title) + '</a>' + variant +
            '<div class="qty" style="margin-top:8px">' +
              '<button type="button" data-qty-down aria-label="Decrease quantity">&minus;</button>' +
              '<input type="number" value="' + item.quantity + '" min="0" aria-label="Quantity" data-qty-input>' +
              '<button type="button" data-qty-up aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="citem__p">' + money(item.final_line_price) + '</div>' +
        '</div>' +
        (i < cart.items.length - 1 ? '<hr class="chain" aria-hidden="true">' : '')
      );
    }).join('');

    var total = $('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);

    updateBelt(cart.total_price);
  }

  function updateBelt(total) {
    var belt = $('[data-belt]');
    if (!belt) return;
    var threshold = parseInt(belt.dataset.threshold, 10);
    if (!threshold) return;
    var pct = Math.min(100, Math.round((total / threshold) * 100));
    var fill = $('[data-belt-fill]', belt);
    var msg = $('[data-belt-msg]', belt);
    if (fill) {
      fill.style.width = pct + '%';
      fill.parentNode.setAttribute('aria-valuenow', pct);
    }
    var remaining = threshold - total;
    if (msg) {
      msg.innerHTML = remaining > 0
        ? money(remaining) + ' away from free shipping'
        : '<b>Free shipping unlocked</b>';
    }
    belt.classList.toggle('belt--done', remaining <= 0);
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* --- quick add -------------------------------------------------------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      addToCart(btn.dataset.variantId, 1, btn);
    });
  }

  /* --- product form ----------------------------------------------------- */
  function initProductForm() {
    $$('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var id = $('[name="id"]', form);
        if (!id || !id.value) return;              // let it POST normally
        e.preventDefault();
        var qty = $('[name="quantity"]', form);
        addToCart(id.value, qty ? parseInt(qty.value, 10) : 1, $('[type="submit"]', form));
      });
    });

    // Variant swatches -> update price, availability, URL, gallery
    $$('[data-variants]').forEach(function (root) {
      var data;
      try { data = JSON.parse($('[data-variant-json]', root).textContent); } catch (err) { return; }

      root.addEventListener('change', function (e) {
        if (!e.target.closest('[data-opt]')) return;
        var chosen = $$('[data-opt]:checked', root).map(function (i) { return i.value; });
        var match = data.find(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        });
        if (!match) return;

        var idField = $('[name="id"]', root);
        if (idField) idField.value = match.id;

        var price = $('[data-pdp-price]', root);
        if (price) {
          price.innerHTML = match.compare_at_price > match.price
            ? '<s>' + money(match.compare_at_price) + '</s> <em>' + money(match.price) + '</em>'
            : money(match.price);
        }

        var submit = $('[data-pdp-submit]', root);
        if (submit) {
          submit.disabled = !match.available;
          submit.querySelector('span').textContent = match.available
            ? (submit.dataset.buyLabel || 'Add to cart')
            : (MP.strings.sold_out || 'Sold out');
        }

        var waitlist = $('[data-waitlist]', root);
        if (waitlist) waitlist.hidden = match.available;

        var sku = $('[data-pdp-sku]', root);
        if (sku && match.sku) sku.textContent = match.sku;

        if (history.replaceState) {
          history.replaceState({}, '', '?variant=' + match.id);
        }

        // jump the gallery to this variant's image
        if (match.featured_media_id) {
          var thumb = $('[data-media-id="' + match.featured_media_id + '"]', root);
          if (thumb) thumb.click();
        }
      });
    });
  }

  /* --- product gallery -------------------------------------------------- */
  function initGallery() {
    $$('[data-gallery]').forEach(function (g) {
      var main = $('[data-gallery-main]', g);
      if (!main) return;
      var thumbs = $$('[data-media-id]', g);

      function show(thumb) {
        var img = $('img', thumb);
        if (!img) return;
        // The stage <img> ships with a srcset. A srcset ALWAYS outranks src,
        // so assigning src alone left the first image on screen forever —
        // srcset has to be replaced (or cleared) in the same breath.
        if (img.dataset.srcset) {
          main.srcset = img.dataset.srcset;
        } else {
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
        }
        main.src = img.dataset.full || img.currentSrc || img.src;
        main.alt = img.alt;
        thumbs.forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
        // un-zoom when the picture changes, otherwise the new shot lands
        // already magnified at a meaningless origin
        wrap.classList.remove('is-zoom');
      }

      g.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-media-id]');
        if (!thumb) return;
        e.preventDefault();
        show(thumb);
      });

      // Left/right arrows step through the strip once a thumb has focus
      g.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var thumb = e.target.closest('[data-media-id]');
        if (!thumb) return;
        e.preventDefault();
        var i = thumbs.indexOf(thumb) + (e.key === 'ArrowRight' ? 1 : -1);
        var next = thumbs[(i + thumbs.length) % thumbs.length];
        next.focus();
        show(next);
      });

      // Hover/touch zoom — transform-origin follows the pointer
      var wrap = main.parentNode;
      wrap.addEventListener('pointermove', function (e) {
        if (reduced || !wrap.classList.contains('is-zoom')) return;
        var r = wrap.getBoundingClientRect();
        main.style.transformOrigin =
          ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      wrap.addEventListener('click', function (e) {
        if (e.target !== main) return;
        wrap.classList.toggle('is-zoom');
      });
    });
  }

  /* --- predictive search ------------------------------------------------ */
  function initSearch() {
    var el = $('[data-psearch]');
    if (!el) return;
    var panel = Panel(el, { focus: '[data-psearch-input]', hideOnClose: true, overlay: true });

    $$('[data-search-open]').forEach(function (b) {
      b.addEventListener('click', function () { panel.open(); });
    });
    $$('[data-search-close]').forEach(function (b) {
      b.addEventListener('click', panel.close);
    });

    var input = $('[data-psearch-input]', el);
    var results = $('[data-psearch-results]', el);
    if (!input || !results) return;

    var timer = null;
    var controller = null;

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) {
        results.setAttribute('hidden', '');
        input.setAttribute('aria-expanded', 'false');
        return;
      }
      timer = setTimeout(function () { run(q); }, 220);
    });

    function run(q) {
      if (controller) controller.abort();
      controller = new AbortController();
      var url = MP.routes.predictive + '?q=' + encodeURIComponent(q) +
                '&resources[type]=product&resources[limit]=6&section_id=predictive-results';
      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var found = doc.querySelector('[data-psearch-payload]');
          results.innerHTML = found ? found.innerHTML : '';
          results.removeAttribute('hidden');
          input.setAttribute('aria-expanded', 'true');
        })
        .catch(function (e) { if (e.name !== 'AbortError') results.setAttribute('hidden', ''); });
    }
  }

  /* --- collection filters ----------------------------------------------- */
  function initFilters() {
    var form = $('[data-filter-form]');
    if (!form) return;

    form.addEventListener('change', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });

    // Mobile filter drawer
    var rail = $('[data-filter-rail]');
    $$('[data-filter-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var open = rail.classList.toggle('is-open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* --- modals (size chart etc.) ----------------------------------------- */
  function initModals() {
    $$('[data-modal]').forEach(function (modal) {
      var panel = Panel(modal, { hideOnClose: true });
      $$('[aria-controls="' + modal.id + '"]').forEach(function (b) {
        b.addEventListener('click', panel.open);
      });
      $$('[data-modal-close]', modal).forEach(function (b) {
        b.addEventListener('click', panel.close);
      });
    });
  }

  /* --- leopard parallax drift ------------------------------------------- */
  function initParallax() {
    if (reduced) return;
    var ticking = false;
    function update() {
      document.body.style.setProperty('--par', (window.scrollY * -0.06).toFixed(1) + 'px');
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
  }

  /* --- scroll reveal ----------------------------------------------------
     Classes are applied here and only here, so a no-JS visitor never gets
     stuck looking at opacity:0 content.                                    */
  function initReveal() {
    if (reduced || !('IntersectionObserver' in window)) return;

    // Explicit opt-ins, plus the recurring components. Listing the pieces
    // rather than blanket-selecting section children keeps the effect on
    // things that read as objects and off wrapper divs.
    var AUTO = [
      '.kicker', '.section-heading', '.sec h2', '.sec .h2', '.sec .lede',
      '.pcard', '.top8__cell', '.collage__it', '.bust', '.look__it',
      '.jcard', '.faq__it', '.hotspot', '.mag__in > *', '.hero__meta',
      '.citem', '.presult', '.dropmark', '.skullrule',
      '.fcol', '.deets', '.tbl', '.auth'
    ].join(',');

    var seen = [];
    var targets = [];
    $$('[data-reveal]').concat($$(AUTO)).forEach(function (el) {
      if (seen.indexOf(el) !== -1) return;
      seen.push(el);
      targets.push(el);
    });
    if (!targets.length) return;

    // Drop anything nested inside another target — a card inside a revealing
    // wrapper would fade twice and arrive at the wrong time.
    targets = targets.filter(function (el) {
      return !targets.some(function (other) {
        return other !== el && other.contains(el);
      });
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });

    targets.forEach(function (t) {
      t.classList.add('reveal');
      if (t.classList.contains('collage__it') || t.classList.contains('dropmark')) {
        t.classList.add('reveal--sticker');
      }
      // Stagger by position within the parent, so each row of a grid cascades
      // instead of the whole page counting up to a 400ms delay.
      var sibs = t.parentNode ? [].slice.call(t.parentNode.children) : [];
      var idx = sibs.indexOf(t);
      t.style.transitionDelay = Math.min(idx * 70, 420) + 'ms';
      io.observe(t);
    });
  }

  /* --- decorative hit counter ------------------------------------------- */
  function initCounter() {
    var el = $('[data-counter]');
    if (!el || reduced) return;
    // Purely ornamental: nudges upward so it feels alive. Not analytics.
    var digits = $$('b', el);
    setInterval(function () {
      var n = parseInt(digits.map(function (d) { return d.textContent; }).join(''), 10) + 1;
      String(n).padStart(digits.length, '0').split('').forEach(function (c, i) {
        if (digits[i]) digits[i].textContent = c;
      });
    }, 9000);
  }

  /* --- boot ------------------------------------------------------------- */
  function init() {
    initNav();
    initCart();
    initQuickAdd();
    initProductForm();
    initGallery();
    initSearch();
    initFilters();
    initModals();
    initParallax();
    initReveal();
    initCounter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor: re-bind after a section is re-rendered
  document.addEventListener('shopify:section:load', init);
})();
